import React, { useState, useEffect } from 'react';
import './ViscosityCalculator.css';

const fromToSec = {
    "Ultra Low Cup": [0, 15.5, 37.333],
    'AFNOR Cup #4': [0, 4.8745, -46.668],
    'B4 Cup': [0, 5, -65],
    'DIN Cup #4': [0, 4.8745, -46.668],
    Dudley: [0, 0.764, -25.55],
    'Fisher Cup #1': [0, 1.072, -11.865],
    'Fisher Cup #2': [-0.0288, 4.1019, -34.599],
    'Ford Cup #2': [0, 1.4688, -27.721],
    'Ford Cup #3': [0, 2.5818, -13.302],
    'Ford Cup #4': [0, 3.6182, 0.0025],
    'ISO Cup #4': [0, 1.476, -8.223],
    'Norcross Cup #1': [0, 0.1581, -3.6006],
    'Norcross Cup #2': [0, 0.4661, -5.7814],
    'Norcross Cup #3': [0, 2.0058, -10.064],
    'Norcross Cup #4': [0, 5.972, -11.975],
    'Norcross Cup #5': [0, 21.139, -56.863],
    'Norcross Cup #6': [0, 94.77, -274.3],
    'Redwood #1': [0, 0.2597, -7.0973],
    'Sears Cup': [1.2238, 0.7692, 42.727],
    'Shell Cup #1': [0, 0.225, 2.8431],
    'Shell Cup #2': [0, 0.5963, -3.2231],
    'Shell Cup #2.5': [0, 0.9226, -2.7848],
    'Shell Cup #3': [0, 1.5177, -3.3168],
    'Shell Cup #3.5': [0, 2.2124, -5.4978],
    'Shell Cup #4': [0, 3.352, -0.2822],
    'Shell Cup #5': [0, 6.25, 0],
    'Shell Cup #6': [0, 16.067, -6.2975],
    SSF: [0, 2.2066, -10.778],
    SSU: [0, 0.22, -5.2727],
    'Stormer 100': [0, 3.1874, -4.3054],
    'Zahn Cup #1': [0, 1.4018, -34.08],
    'Zahn Cup #2': [0, 2.7823, -21.55],
    'Zahn Cup #3': [0, 9.4997, -58.956],
    'Zahn Cup #4': [0, 15.367, -77.861],
    'Zahn Cup #5': [0, 22.27, -91.351],
};

const secTocP = {
    "Ultra Low Cup": [2.4071, 0.0645, 52, 85],
    'AFNOR Cup #4': [46.668, 4.8745, 19, 72],
    'B4 Cup': [65, 5, 16, 20],
    'DIN Cup #4': [46.668, 4.8745, 19, 62],
    Dudley: [25.55, 0.764, 34, 74],
    'Fisher Cup #1': [11.865, 1.072, 19, 49],
    'Fisher Cup #2': [0.002, 0.1349, 11.53, 14, 52],
    'Ford Cup #2': [27.721, 1.4688, 39, 105],
    'Ford Cup #3': [13.302, 2.5818, 31, 131],
    'Ford Cup #4': [-0.0025, 3.6182, 19, 104],
    'ISO Cup #4': [8.223, 1.476, 25, 61],
    'Norcross Cup #1': [3.6006, 0.1581, 30, 88],
    'Norcross Cup #2': [5.7814, 0.4661, 18, 77],
    'Norcross Cup #3': [10.064, 2.0058, 16, 80],
    'Norcross Cup #4': [11.975, 5.972, 17, 86],
    'Norcross Cup #5': [56.863, 21.139, 19, 86],
    'Norcross Cup #6': [274.3, 94.77, 18, 101],
    'Redwood #1': [7.0973, 0.2597, 28, 7641],
    'Sears Cup': [72.843, 6.2316, 18, 45],
    'Shell Cup #1': [2.8431, 0.225, 16, 58],
    'Shell Cup #2': [3.2231, 0.5963, 17, 57],
    'Shell Cup #2.5': [2.7848, 0.9226, 18, 58],
    'Shell Cup #3': [3.3168, 1.5177, 18, 56],
    'Shell Cup #3.5': [5.4978, 2.2124, 17, 60],
    'Shell Cup #4': [0.2822, 3.352, 17, 61],
    'Shell Cup #5': [0, 6.25, 15, 65],
    'Shell Cup #6': [6.2975, 16.067, 17, 79],
    SSF: [10.778, 2.2066, 12, 1628],
    SSU: [5.2727, 0.22, 30, 16271],
    'Stormer 100': [4.3054, 3.1874, 2, 151],
    'Zahn Cup #1': [34.08, 1.4018, 30, 69],
    'Zahn Cup #2': [21.55, 2.7823, 17, 73],
    'Zahn Cup #3': [58.956, 9.4997, 16, 71],
    'Zahn Cup #4': [77.861, 15.367, 16, 71],
    'Zahn Cup #5': [91.351, 22.27, 16, 61],
};

function ViscosityCalculator() {
  const [fromUnit, setFromUnit] = useState("Fisher Cup #2");
  const [toUnit, setToUnit] = useState("Zahn Cup #2");
  const [inputValue, setInputValue] = useState("20");
  const [resultSeconds, setResultSeconds] = useState("");
  const [resultCp, setResultCp] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    viscosityCalc();
  }, []);

  useEffect(() => {
    if (inputValue.length !== 0) {
      viscosityCalc();
    } else {
      setResultSeconds("");
      setResultCp("");
      setErrorMessage("");
    }
  }, [fromUnit, toUnit, inputValue]);

  const viscosityCalc = () => {
    if (fromUnit === toUnit) {
      // Si las unidades son iguales, el resultado es el mismo que la entrada
      setResultSeconds(inputValue);
      setResultCp("");
      setErrorMessage("");
      return;
    }

    const cP =
      +inputValue * +inputValue * fromToSec[fromUnit][0] +
      +inputValue * fromToSec[fromUnit][1] +
      fromToSec[fromUnit][2];

    let sec;
    if (toUnit === 'Fisher Cup #2') {
      sec = cP * cP * secTocP[toUnit][0] +
        cP * secTocP[toUnit][1] +
        secTocP[toUnit][2];
    } else {
      sec = (cP + secTocP[toUnit][0]) / secTocP[toUnit][1];
    }

    if (sec < secTocP[toUnit][secTocP[toUnit].length - 2]) {
      setErrorMessage(`The viscosity of this fluid (and the cP value) are too low to accurately measure with this ${toUnit}.`);
      setResultSeconds("");
      setResultCp("");
    } else if (sec > secTocP[toUnit][secTocP[toUnit].length - 1]) {
      setErrorMessage(`The viscosity of this fluid (and the cP value) are too high to accurately measure with this ${toUnit}.`);
      setResultSeconds("");
      setResultCp("");
    } else {
      setErrorMessage("");
      setResultSeconds(sec.toFixed(2));
      setResultCp(cP.toFixed(2));
    }
  };

  return (
    <div className="viscosity-calculator">
      <h3 className="left-aligned-title">Cup Seconds</h3>
      <div className="conversion-input">
        <input
          type="number"
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          placeholder="Enter value"
        />
        <select value={fromUnit} onChange={(e) => setFromUnit(e.target.value)}>
          {Object.keys(fromToSec).map(unit => (
            <option key={unit} value={unit}>{unit}</option>
          ))}
        </select>
      </div>
      <div className="conversion-input">
        <input
          type="number"
          value={resultSeconds}
          readOnly
          placeholder="Result"
        />
        <select value={toUnit} onChange={(e) => setToUnit(e.target.value)}>
          {Object.keys(secTocP).map(unit => (
            <option key={unit} value={unit}>{unit}</option>
          ))}
        </select>
      </div>
      {resultCp && !errorMessage && (
        <div className="cp-result">
          {resultCp} cP
        </div>
      )}
      {errorMessage && (
        <div className="error-message">
          {errorMessage}
        </div>
      )}
    </div>
  );
}

export default ViscosityCalculator;